import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
// import Slide from '@mui/material/Slide';
// import { TransitionProps } from '@mui/material/transitions';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import usePostRequest from '../../hooks/usePostRequest';
import { extractValue } from '../../Utils/utils';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
import { Transition } from '../shared/ReusableSmallComponents';

// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<any, any>;
//   },
//   ref: React.Ref<unknown>,
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

export default function DialogAnnulerPublication({ selectedAOs,refresh,openValiderAnnulation, setOpenValiderAnnulation }) {
    DialogAnnulerPublication.propTypes = {
        selectedAOs: PropTypes.any,
        openValiderAnnulation: PropTypes.any,
        setOpenValiderAnnulation: PropTypes.func,
        refresh:PropTypes.func,
    };
    const { postData } = usePostRequest();
    const AOsIds = extractValue(selectedAOs, '_id');
    const { i18n } = useTranslation();
    const handleCloseDialog = () => {
        setOpenValiderAnnulation(false);
        refresh();
    };
    const annulerPublication = async () => {
        try {
            postData({
                url: '/ao/annulerPublication', payload: {
                    AOsIds
                }
            });
            handleCloseDialog();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
            handleCloseDialog();
        }
    };
    return (
        <Dialog
            open={openValiderAnnulation}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleCloseDialog}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{i18n.t('Etes-vous sûr de vouloir clôturer la publication ?')}</DialogTitle>
            {/* <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam quis.
                </DialogContentText>
            </DialogContent> */}
            <DialogActions>
                <Button
                    variant="outlined"
                    style={{...buttonStyles()}}
                    onClick={handleCloseDialog}
                >{i18n.t('Retour')}</Button>
                <Button
                    variant="outlined"
                    style={{...buttonStyles()}}
                    onClick={annulerPublication}
                >{i18n.t('Oui')}</Button>
            </DialogActions>
        </Dialog>
    );
}